export default __webpack_public_path__ + "static/media/04AW2MAR66.f67d7ed7.jpg";